import React from "react";
import { CtaButton } from "./CtaButton";
interface StickyOfferBarProps {
  visible: boolean;
}
export function StickyOfferBar({
  visible
}: StickyOfferBarProps) {
  if (!visible) return null;
  return <div className="sticky-offer" role="region" aria-label="Kit offer" data-id="element-281" data-mp="2p6xsirevo377">
      <div className="shell" data-id="element-282" data-mp="2k8o18rw9xmqv">
        <p data-id="element-283" data-mp="2k7l8eefe5a8b">
          <strong data-id="element-284" data-mp="2k7v0q8nwrth6">Sales Team Practice Ready</strong>
          <span data-id="element-285" data-mp="2f9jmllqkywt5">Volume 1 · 5 workshops + 5 bonuses · $27 USD one time</span>
        </p>
        <CtaButton href="#offer-details" small data-id="element-286" data-mp="2f770cwdsi0aa">
          See offer — $27
        </CtaButton>
      </div>
    </div>;
}